export const GATEWAY_API_BASEPATH = process.env.REACT_APP_GATEWAY_API_BASEPATH
export const AM_API_BASEPATH = process.env.REACT_APP_GATEWAY_SURVEY_API_BASEPATH
export const GATEWAY_API_HEALTH_URL = `${GATEWAY_API_BASEPATH}/health`
export const GATEWAY_API_USER_URL = `${GATEWAY_API_BASEPATH}/userinfo`
export const GATEWAY_API_USERS_URL = `${GATEWAY_API_BASEPATH}/users`
export const GATEWAY_API_GROUPS_URL = `${GATEWAY_API_BASEPATH}/groups`
export const GATEWAY_API_APPS_URL = `${GATEWAY_API_BASEPATH}/apps`
export const GATEWAY_API_ERROR_URL = `${GATEWAY_API_BASEPATH}/error`
export const GATEWAY_API_CAMPIAGN_URL = `${GATEWAY_API_BASEPATH}/campaigns`
export const GATEWAY_API_USER_REGISTERED_APPS_URL = `${GATEWAY_API_BASEPATH}/api/me/applications`
export const GATEWAY_API_SUPPORT_MAIL = `${AM_API_BASEPATH}/support/mail`
export const OKTA_ISSUER = process.env.REACT_APP_OKTA_ISSUER
export const OKTA_CLIENTID = process.env.REACT_APP_OKTA_CLIENTID
export const GA_ID = process.env.REACT_APP_GA_ID
export const JANSSEN_OKTA_ISSUER = process.env.REACT_APP_JANSSEN_OKTA_ISSUER
export const JANSSEN_OKTA_CLIENTID = process.env.REACT_APP_JANSSEN_OKTA_CLIENTID
export const OKTA_BASE_REDIRECT_URI =
  process.env.REACT_APP_OKTA_BASE_REDIRECT_URI
export const LINK_REPORT_DASHBOARD = process.env.REACT_APP_LINK_REPORT_DASHBOARD
export const LABEL_REPORT_DASHBOARD = process.env.REACT_APP_LABEL_REPORT_DASHBOARD
export const SURVEY_TEMPLATE_TAG_HOME = process.env.REACT_APP_SURVEY_TEMPLATE_TAG_HOME
export const SURVEY_TEMPLATE_TAG_BULK_UPLOAD = process.env.REACT_APP_SURVEY_TEMPLATE_TAG_BULK_UPLOAD
export const LINK_CONSENT_REPORT_DASHBOARD = process.env.REACT_APP_LINK_CONSENT_REPORT_DASHBOARD
export const LABEL_CONSENT_REPORT_DASHBOARD = process.env.REACT_APP_LABEL_CONSENT_REPORT_DASHBOARD
export const LINK_IGA_REPORT_DASHBOARD = process.env.REACT_APP_LINK_IGA_REPORT_DASHBOARD
export const LABEL_IGA_REPORT_DASHBOARD = process.env.REACT_APP_LABEL_IGA_REPORT_DASHBOARD
export const TENANT_CUSTOM_ATTRIBUTE_SCHEMA = process.env.REACT_APP_TENANT_CUSTOM_ATTRIBUTE_SCHEMA

export const OKTA_CONFIG_OBJ = {
  issuer: OKTA_ISSUER,
  clientId: OKTA_CLIENTID,
  redirectUri: `${OKTA_BASE_REDIRECT_URI}/login/callback`,
  restoreOriginalUri: async (oktaAuth, originalUri) => {
    window.location.replace(originalUri)
  },
}

export const JANSSEN_OKTA_CONFIG_OBJ = {
  issuer: JANSSEN_OKTA_ISSUER,
  clientId: JANSSEN_OKTA_CLIENTID,
  redirectUri: `${OKTA_BASE_REDIRECT_URI}/login/callback`,
  restoreOriginalUri: async (oktaAuth, originalUri) => {
    window.location.replace(originalUri)
  },
}
export const SIDE_MENU_SECTIONS = [
  {
    name: 'Users',
    open: true,
    links: [
      { label: 'Create User', path: '/create-user' },
      { label: 'User Search', path: '/search-user' },
    ],
  },
  {
    name: 'Groups',
    open: true,
    links: [
      { label: 'Create Group', path: '/create-group' },
      { label: 'Group Search', path: '/search-group' },
    ],
  },

  {
    name: 'Applications',
    open: true,
    path: '/not-available',
    links: [
      // { label: 'Create Applications', path: '/create-application' },
      // { label: 'Search Applications', path: '/search-application' },
    ],
  },
  {
    name: 'Access Certifications',
    open: true,
    path: '/not-available',
    links: [
     // { label: 'Manage Certifications', path: '/create-campaign/0' },
  ], }
  // {
  // name: 'Audits',
  // open: false,
  // links: [{ label: 'Search Audit', path: '/search-audit' }],
  // },
  // {
  //   name: 'Access Request',
  //   open: false,
  //   links: [{ label: 'Pending Request', path: '/pending-request' }],
  // },
  // {
  //   name: 'Brannds',
  //   open: false,
  //   links: [
  //     { label: 'Create Brand', path: '/' },
  //     { label: 'Modify Brand', path: '/' },
  //   ],
  // },
]

export const domains = [{
  domainName: 'dev.login.jnj.com',
  companyName: 'J&J'
}];

export const colors = ['#f1e1d4', '#dac9ac', '#fadcd2', '#dfb6a4', '#c38a81', '#f5b381', '#dac3ba']

export const BANNER_MENU_SECTIONS = [
  {
    label: 'home-tab',
    path: '/'
  },
  {
    label: 'admin-tools-tab',
    dropdown: [
        {
            label: 'users-create-tab',
            path: '/create-user',
        },
        {
            label: 'users-edit-tab',
            path: '/search-user',
        },
        {
            label: 'groups-create-tab',
            path: '/create-group',
        },
        {
            label: 'groups-edit-tab',
            path: '/search-group',
        },
        {
            label: 'audit-user-log-tab',
            path: '/user-activities',
        },
        {
            label: 'audit-bulk-status-tab',
            path: '/bulk-users-activity',
        },
        {
            label: 'reports-tab',
            path: LINK_REPORT_DASHBOARD,
            shouldOpenInNewTab: true,
        },
    ]
  },
  {
    label: 'support-tab-title',
    path: '/support'
  }
]
export const BANNER_DROPDOWN_MENU_SECTIONS = [
  {
    label: 'my-profile-tab',
    path: '/user-profile',
  },
  {
    label: 'sign-out-tab',
    path: '/logout',
    color: 'red'
  }
]
export const HAMBURGER_MENU_SECTIONS = [
  [
    {
      label: 'home-tab',
      path: '/home'
    },
    {
      label: 'my-account-tab',
      path: '/user-profile'
    },
    {
      label: 'support-tab-title',
      path: '/support'
    },
  ],
  [
    {
      label: 'sign-out-tab',
      path: '/logout'
    },
  ]
]

export const SURVEY_TEMPLATE_SCHEMA = `{
  "id": "OA-2024-07-23-1",
  "schema": "1.0.0",
  "questions": [
    {
      "id": "1a",
      "type": "emotion_select",
      "label": {
        "en-US": "",
        "es-ES": "",
        "nl-NL": "",
        "de-DE": "",
        "ko-KR": "",
        "pt-PT": "",
        "ja-JP": "",
        "fr-FR": ""
      },
      "answers": [
        {
          "en-US": "It was great!",
          "es-ES": "¡Fue genial!",
          "nl-NL": "Het was geweldig!",
          "de-DE": "Es war großartig!",
          "ko-KR": "정말 좋았어요!",
          "pt-PT": "Foi ótimo!",
          "ja-JP": "素晴らしかったです！",
          "fr-FR": "C'était génial!"
        },
        {
          "en-US": "It was OK",
          "es-ES": "Estuvo bien",
          "nl-NL": "Het was oké",
          "de-DE": "Es war okay",
          "ko-KR": "괜찮았어요",
          "pt-PT": "Foi ok",
          "ja-JP": "まあまあでした",
          "fr-FR": "C'était correct"
        },
        {
          "en-US": "Needs improvement",
          "es-ES": "Esto necesita mejorar",
          "nl-NL": "Moet verbeterd worden",
          "de-DE": "Muss verbessert werden",
          "ko-KR": "개선이 필요해요",
          "pt-PT": "Precisa melhorar",
          "ja-JP": "改善が必要です",
          "fr-FR": "Doit être amélioré"
        }
      ],
      "required": true
    },
    {
      "id": "1b",
      "type": "free_response",
      "label": {
        "en-US": "Please tell us what needs improvement (optional)",
        "es-ES": "Por favor díganos qué necesita mejorar (opcional)",
        "nl-NL": "Vertel ons wat er verbeterd moet worden (optioneel)",
        "de-DE": "Bitte sagen Sie uns, was verbessert werden muss (optional)",
        "ko-KR": "무엇을 개선해야 하는지 알려주세요 (선택 사항)",
        "pt-PT": "Por favor, diga-nos o que precisa melhorar (opcional)",
        "ja-JP": "改善すべき点を教えてください（任意）",
        "fr-FR": "Veuillez nous dire ce qui doit être amélioré (facultatif)"
      },
      "required": false,
      "dependentOn": {
        "id": "1a",
        "answer": [2]
      }
    }
  ]
}`

export const SURVEY_TEMPLATE = JSON.parse(SURVEY_TEMPLATE_SCHEMA)
